<div id="loding" [ngClass]="{ 'loding-hide': lodingImage }">
  <img src="assets/img/loding.gif" />
</div>

<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12 headboxes">
        <div class="card p-0">
          <div class="card-block p-0">
            <div class="heading-box" style="background-image: none">
              <div class="row align-items-center">
                <div class="col-md-10">
                  <div class="partner-iocn">
                    <!-- <img
                      *ngIf="onboardOrg.image"
                      [src]="onboardOrg.image"
                      style="height: 100px; width: 100px"
                    />
                    <img
                      *ngIf="!onboardOrg.image"
                      src="assets/img/default-profile.png"
                      class="img-fluid"
                      alt=""
                    /> -->
                    <h4>Onboard Organization Details</h4>
                  </div>
                </div>

              

                <div class="col-md-2 text-right">
                  <div class="excel">
                    <button
                      type="button"
                      class="btn btn-primary addbtn ml-3"
                      (click)="onBack()"
                    >
                      <i class="fa fa-long-arrow-left"></i> Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12" >
        <div class="card">
          <div class="card-block partnerview">
            <div class="row">
              <div class="col-md-12">
                <h4>Basic Details</h4>
                <hr />
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for=""> Name</label>
                  <p>{{ onboardOrg.name }}</p>
                </div>
              </div>

               <div class="col-md-6">
                <div class="form-group">
                  <label for=""> Service Provider Name</label>
                  <p>{{ onboardOrg.service_provider_others ? onboardOrg.service_provider_others : onboardOrg.service_provider_name }}</p>
                </div>
              </div>
 <div class="col-md-6">
                <div class="form-group">
                  <label for="">Short Description</label>
                  <p>{{ onboardOrg.short_description }}</p>
                </div>
              </div>
             

              <div class="col-md-6">
                <div class="form-group">
                  <label for=""> Type</label>
                  <p>{{ onboardOrg.type_others ? onboardOrg.type_others : onboardOrg.type_name }}</p>
                </div>
              </div>

             

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Website</label>
                  <p>{{ onboardOrg.website }}</p>
                </div>
              </div>

             

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Address</label>
                  <p>{{ onboardOrg.address }}</p>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">State Name</label>
                  <p>{{ onboardOrg.state_name }}</p>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">District Name</label>
                  <p>{{ onboardOrg.district_name }}</p>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Details of Service</label>
                  <p>{{ onboardOrg.details_of_service }}</p>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Focus Sector</label>
                  <p>{{ onboardOrg.focus_sector_others ? onboardOrg.focus_sector_others : onboardOrg.focus_sector_name}}</p>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Mode of Delivery</label>
                  <p>{{ onboardOrg.mode_of_delivery_name }}</p>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Startup Stage Support</label>
                  <p>{{ onboardOrg.startup_stage_support_others? onboardOrg.startup_stage_support_others : onboardOrg.startup_stage_support_name }}</p>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Eligibility Criteria </label>
                  <p>{{ onboardOrg.eligibility_criteria_others? onboardOrg.eligibility_criteria_others : onboardOrg.eligibility_criteria_name  }}</p>
                </div>
              </div>

              <div class="col-md-6" *ngIf="onboardOrg.eligibility_criteria_threshold">
                <div class="form-group" >
                  <label for="">Eligibility Criteria Threshold </label>
                  <p>{{ onboardOrg.eligibility_criteria_threshold }}</p>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Pricing Model Name</label>
                  <p>{{ onboardOrg.pricing_model_others ?  onboardOrg.pricing_model_others : onboardOrg.pricing_model_name }}</p>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Link to Brochure</label>
                  <p>{{ onboardOrg.link_to_brochure }}</p>
                </div>
              </div>

              
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Duration</label>
                  <p>{{ onboardOrg.duration }}</p>
                </div>
              </div>

             
              
            </div>
          </div>

          <div
            class="card-block"
            *ngIf="onboardOrg.approve_status != 'SUBMITTED'"
          >
            <div class="partner-action p-3">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="atr_remarks">Remarks</label>
                    <form [formGroup]="remarkForm">
                      <textarea
                        class="form-control"
                        name="remarks"
                        id="atr_remarks"
                        formControlName="remarks"
                        rows="3"
                      ></textarea>

                      <div
                        *ngIf="
                          remarks.invalid && (remarks.dirty || remarks.touched)
                        "
                        class="alert"
                      >
                        <div
                          class="text-danger"
                          *ngIf="
                            remarks?.errors?.whitespace &&
                            (remarks.dirty || remarks.touched)
                          "
                        >
                          <p>This field is required</p>
                        </div>

                        <div *ngIf="errorMessage" class="alert alert-danger">
                          {{ errorMessage }}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="col-md-12 align-self-center">
                  <div *ngIf="is_Error" class="text-danger text-sm mb-2">
                    {{ api_error }}
                  </div>
                  <div class="actiobtn">
                    <!-- <button type="submit" (click)="rejectStatus('SAVE_AS_DRAFT')"
                                            class="btn btn-dark mr-2" >Save as Draft</button> -->
                    <button
                      type="submit"
                      (click)="saveSubmit('APPROVED')"
                      class="btn btn-primary mr-2 addbtn"
                    >
                      Approve
                    </button>
                    <button
                      type="submit"
                      (click)="rejectStatus('REJECTED')"
                      class="btn btn-success addbtn mr-2"
                    >
                      Reject
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card-block">
            <div
              class="partner-action p-3"
              *ngIf="onboardOrg.approve_status == 'SUBMITTED'"
            >
              <div class="text-center font-weight-bold">Approved</div>
            </div>
          </div>
        </div>
      </div>

     
    </div>
  </div>
</div>
